var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 40.1l-6.9-6.9c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l8.3 8.4c.8.8 2 .8 2.8 0l21.2-21.2c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0L25.8 40.1zM0 32c0 17.7 14.3 32 32 32s32-14.3 32-32S49.7 0 32 0 0 14.4 0 32zm4 0C4 16.6 16.5 4 32 4s28 12.5 28 28-12.5 28-28 28S4 47.5 4 32z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}
export default SvgSuccessIcon;